<div class="ttmodal" *ngIf="isAddSlide">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Add Slide</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body">
    <div class="input-container flexInput">
      <span class="label">Slide Name <span class="red-text"></span></span>

      <input class="input-text" [(ngModel)]="slideName" type="text" placeholder="Slide Name" required>
    </div>
    <div class="input-container flexInput" style="margin-top: 3%;">
      <span class="label" >Select Slide Type <span class="red-text"></span></span>
      <mat-radio-group aria-label="Select Slide Type" (change)="ChangeSlideType()" [(ngModel)]="SlideTypeId">
        <mat-radio-button [value]="1">Image</mat-radio-button>
        <mat-radio-button [value]="2">URL</mat-radio-button>
      </mat-radio-group>
    </div>
    <span *ngIf="SlideTypeId==1" class="label" style="font-size: large;text-decoration: underline;float: left;">Slide images must be .png or .jpg format and ideally 600px x 800px</span>
    <div *ngIf="SlideTypeId==1">
      <img style="width:50%" *ngIf="SlideImage" [src]="sanitize(SlideImage)">
      <img style="width:50%" src="../../../../../../Content/Images/NO-IMAGE.png" *ngIf="!SlideImage">
      <input style="display: none" type="file" (change)="onSelectPhoto($event)" #fileInput>
      <button class="choose-image-btn" mat-raised-button (click)="fileInput.click()"> Choose file </button>
    </div>


    <div *ngIf="SlideTypeId==2">
      <img style="width: 90%;margin: 5%;" src="../../../../../../Content/Images/VideoURL.png" />
    </div>

    <div class="input-container flexInput" *ngIf="SlideTypeId==2">
      <span class="label">Youtube Video Id <span class="red-text"></span></span>

      <input class="input-text" [(ngModel)]="link" type="text" placeholder="Youtube Link Id" required>
    </div>
  </div>

  <div class="ttmodal__footer">
    <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
    <a class="button button--primary" (click)="onAddSlide()"><span class="button__text">Add Slide</span></a>
  </div>
</div>

<div class="ttmodal" *ngIf="isEditSlide">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Update Slide</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body">
    <div class="input-container flexInput">
      <span class="label">Slide Name <span class="red-text"></span></span>

      <input class="input-text" [(ngModel)]="slideName" type="text" placeholder="Slide Name" required>
    </div>
    <div class="input-container flexInput" style="margin-top: 3%;">
      <span class="label">Select Slide Type <span class="red-text"></span></span>
      <mat-radio-group aria-label="Select Slide Type" (change)="ChangeSlideType()" [(ngModel)]="SlideTypeId">
        <mat-radio-button [value]="1">Image</mat-radio-button>
        <mat-radio-button [value]="2">URL</mat-radio-button>
      </mat-radio-group>
    </div>
    <span *ngIf="SlideTypeId==1" class="label" style="font-size: large;text-decoration: underline;float: left;">Slide images must be .png or .jpg format and ideally 600px x 800px</span>
    <div *ngIf="SlideTypeId==1">
      <img style="width:50%" *ngIf="SlideImage" [src]="sanitize(SlideImage)">
      <img style="width:50%" src="../../../../../../Content/Images/NO-IMAGE.png" *ngIf="!SlideImage">
      <input style="display: none" type="file" (change)="onSelectPhoto($event)" #fileInput>
      <button class="choose-image-btn" mat-raised-button (click)="fileInput.click()"> Choose file </button>
    </div>


    <div *ngIf="SlideTypeId==2">
      <img style="width: 90%;margin: 5%;" src="../../../../../../Content/Images/VideoURL.png" />
    </div>

    <div class="input-container flexInput" *ngIf="SlideTypeId==2">
      <span class="label">Youtube Video Id <span class="red-text"></span></span>

      <input class="input-text" [(ngModel)]="link" type="text" placeholder="Youtube Link Id" required>
    </div>
  </div>

  <div class="ttmodal__footer">
    <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
    <a class="button button--primary" (click)="onEditSlide()"><span class="button__text">Update</span></a>
  </div>
</div>

